import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

// Stripe status values that mean a renewal charge failed. `past_due` still
// counts as "active" on the backend (see subscription_is_active — it's an
// intentional grace period for API/background-sync access), but the app UI
// should still steer the user to fix their card instead of using the app.
const PAYMENT_FAILED_STATUSES = ['past_due', 'unpaid'];

// Blocks access to children unless the user has an active (or admin-bypassed) subscription.
const RequireSubscription = ({ children }) => {
  const { user, loading, isAdmin, isConsultant, subscriptionStatus, hasActiveSubscription } = useAuth();

  if (loading || (user && subscriptionStatus === null)) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (isConsultant) {
    return <Navigate to="/afiliados" replace />;
  }

  if (!isAdmin && PAYMENT_FAILED_STATUSES.includes(subscriptionStatus)) {
    return <Navigate to="/update-payment" replace />;
  }

  if (!hasActiveSubscription) {
    return <Navigate to="/select-plan" replace />;
  }

  return children;
};

export default RequireSubscription;
